import { Routes } from '@angular/router';

import { CheckoutResolver } from '@base/resolvers/checkout.resolver';
import { RedirectResolver } from '@base/resolvers/redirect.resolver';

import { CartComponent } from '@tunnel/cart/cart.component';
import { PaymentRedirectComponent } from '@tunnel/payment-redirect/payment-redirect.component';

const appRoutes: Routes = [
    {
        path: 'panier',
        component: CartComponent,
    },
    {
        path: 'tunnel',
        loadChildren: () => import('./tunnel/tunnel.routes').then((m) => m.TunnelRoutes),
    },
    {
        path: '',
        redirectTo: 'panier',
        pathMatch: 'full',
    },
];

export const routes: Routes = [
    {
        path: '',
        children: appRoutes,
        resolve: {
            checkout: CheckoutResolver,
        },
    },
    {
        path: 'tunnel/redirect',
        component: PaymentRedirectComponent,
        resolve: {
            redirect: RedirectResolver,
        },
    },
    {
        path: 'tunnel/banque',
        resolve: {
            redirect: RedirectResolver,
        },
        loadComponent: () =>
            import('../app/tunnel/payment-redirect/payment-redirect-bank/payment-redirect-bank.component').then(
                (m) => m.PaymentRedirectBankComponent,
            ),
    },
];
